// Simple opt-out management (for privacy policy compliance)
export const analyticsOptOut = {
  optOut: () => {
    localStorage.setItem('analytics_opt_out', 'true');
    if (typeof window !== 'undefined' && window.posthog) {
      window.posthog.opt_out_capturing();
    }
  },
  optIn: () => {
    localStorage.removeItem('analytics_opt_out');
    if (typeof window !== 'undefined' && window.posthog) {
      window.posthog.opt_in_capturing();
    }
  },
  hasOptedOut: () => {
    return localStorage.getItem('analytics_opt_out') === 'true';
  }
}; 